export default __webpack_public_path__ + "static/media/a037-student-t3-s3-5.6dfee43e.svg";